module.exports = __webpack_public_path__ + "202419:4ba491f0bd9615732354/img/mobile-phones@1x.f32a742.png";